export default __webpack_public_path__ + "static/media/2.912a2a1f.svg";